







































































import { Vue, Component, Prop } from "vue-property-decorator";
import { getSealList, getUserConfig } from "../../api";
import { current } from "@szgc/plt-core-v2";
import FileSign from "../../file/FileSign.vue";

const VueDragResize = require("vue-drag-resize");
@Component({
  name: "Signature",
  components: {
    JGSign: FileSign,
    VueDragResize: VueDragResize.default,
    handSign: () => import("./components/handSign.vue")
  }
})
export default class Signature extends Vue {
  @Prop({
    required: true
  })
  private visible!: boolean;
  @Prop({
    required: true
  })
  private target: any;
  private docImgList: any = []; // 文档图片列表
  private signPickVisible: boolean = false;
  // 当前展示的文档的图片
  private currentDocImg: any = {};
  // 可用的签章图片列表
  private sealList: any = [];
  // 签章记录信息
  private handSignInfo: any = {};
  // 手写签名记录信息
  private sealRecord: any = [];
  // 签章轮播图当前索引
  private currentIndex: any = 0;
  showSignPick() {
    if (this.target.signType === "1") {
      // TODO 替换类型判断
      this.signPickVisible = true;
      // 平台签
    } else {
      // 商务签
      (this.$refs as any).fileSign.show();
    }
  }
  onSignOk(sign: any) {
    console.log(sign);
    // 初始化宽高 位置
    // 记录所属文档页数
    this.sealRecord.push({
      signAttId: "",
      requestRelativeUri: sign.imgData,
      userId: "",
      x: 20,
      y: 20,
      width: "90",
      height: "90",
      pngId: this.currentDocImg.pngId,
      page: this.currentDocImg.pageNum,
      // 下面是商务签内容
      keySn: sign.keySn,
      password: sign.password,
      signName: sign.signName
    });
  }
  onSealResize(e: any, index: any) {
    const { left, top, width, height } = e;
    const seal = this.sealRecord[index];
    seal.x = left;
    seal.y = top;
    seal.width = width;
    seal.height = height;
  }
  onChangeIndex(i: any) {
    // carousel太拉胯 居然只给了这个api记录当前索引
    this.currentIndex = i;
  }
  onHandSign() {
    (this.$refs.handSign as any).show();
  }
  onSubmit() {
    const current =
      this.currentIndex < this.sealList.length
        ? this.sealList[this.currentIndex]
        : this.handSignInfo;
    const { attId, requestRelativeUri, userId } = current;
    // 初始化宽高 位置
    // 记录所属文档页数
    this.sealRecord.push({
      signAttId: attId,
      requestRelativeUri,
      userId,
      x: 20,
      y: 20,
      width: 200,
      height: 200,
      pngId: this.currentDocImg.pngId,
      page: this.currentDocImg.pageNum
    });
    this.signPickVisible = false;
  }
  // 初始化数据
  initData() {
    this.docImgList = this.target?.pngAtts;
    this.currentDocImg = this.docImgList[0] || {};
    this.sealRecord = this.target?.signInfos || [];
  }
  // 获取可用签章图片list
  async getSealList() {
    const { data } = await getSealList();
    this.sealList = data;
  }
  async getHandSignInfo() {
    const { data: handSign } = await getUserConfig(current.userId, "taoHong");
    this.handSignInfo = {
      userId: current.userId,
      type: "sign",
      attId: "",
      requestRelativeUri: handSign?.content
    };
  }
  mounted() {
    // 基础签章
    this.getSealList();
    this.getHandSignInfo();
    this.initData();
  }
}
